import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ai-handoff" }
const _hoisted_2 = {
  key: 1,
  class: "ai-handoff-panel"
}
const _hoisted_3 = { class: "ai-handoff-row" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { value: null }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "ai-handoff-hint" }
const _hoisted_8 = {
  key: 0,
  class: "ai-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ai-btn ai-btn-ghost ai-handoff-open",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show()))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [
            _createElementVNode("path", { d: "M2 21l21-9L2 3v7l15 2-15 2z" })
          ], -1),
          _createTextVNode(" Send to someone else to build ", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "ai-handoff-label",
              for: "ai-handoff-to"
            }, "Who builds it?", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "ai-handoff-to",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toUserID) = $event)),
              disabled: _ctx.busy || _ctx.loading,
              class: "ai-handoff-select"
            }, [
              _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.loading ? 'Loading…' : _ctx.builders.length ? 'Choose a person…' : 'No one else can edit the playbook'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.builders, (b) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: b.userID,
                  value: b.userID
                }, _toDisplayString(b.name), 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_4), [
              [_vModelSelect, _ctx.toUserID]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["ai-btn", { 'disable-button': !_ctx.toUserID || _ctx.busy }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.send()))
            }, _toDisplayString(_ctx.busy ? (_ctx.pct !== null ? 'Sending… ' + _ctx.pct + '%' : 'Sending…') : 'Send the recording'), 3),
            (!_ctx.busy)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "ai-handoff-cancel",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.open = false), ["prevent"]))
                }, "Cancel"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _cache[6] || (_cache[6] = _createTextVNode("They get an email with the recording, and it waits under ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("strong", null, "My AI Captures", -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" for you both until they build or discard it. Your note above goes with it. Nothing is sent to the AI until they press Build. It's set to build a ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.typeNoun), 1),
            _cache[9] || (_cache[9] = _createTextVNode("; they can change that, and whether the video is kept, before they build.", -1))
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]))
  ]))
}